import { render } from "./EmployeeEducation.vue?vue&type=template&id=7780ac13&scoped=true"
import script from "./EmployeeEducation.vue?vue&type=script&lang=js"
export * from "./EmployeeEducation.vue?vue&type=script&lang=js"

import "./EmployeeEducation.vue?vue&type=style&index=0&id=7780ac13&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7780ac13"]])

export default __exports__